import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicForgotUsername = React.lazy(() => import(/* webpackChunkName: "dynamic-forgot-username" */ './DynamicForgotUsername'));

componentService.registerPageComponents({ 'dynamic-forgot-username': DynamicForgotUsername });
